<template>
	<div>
		<div class="header">
			<h3 class="primary--text text-lg-left mb-2 header-title">
				{{ $t('projects.general-settings') }}
			</h3>
		</div>

		<v-container grid-list-md text-xs-right>
			<v-form ref="form" class="xs12">
				<v-layout row wrap>
					<template>
						<v-flex xs12>
							<v-text-field light lazy filled v-model="name" :label="$t('projects.name')"
										:placeholder="$t('projects.name')"></v-text-field>
						</v-flex>
						<v-flex xs12>
							<v-text-field light lazy filled v-model="url" :label="$t('projects.url')"
										:placeholder="$t('projects.url')"></v-text-field>
						</v-flex>
					</template>
				</v-layout>
			</v-form>
			<v-btn color="primary"
				:loading="isSaving"
				@click="save()">
				{{ $t('save') }}
			</v-btn>
		</v-container>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { createHelpers } from 'vuex-map-fields';

	const { mapFields } = createHelpers({
		getterType: 'project/getField',
		mutationType: 'project/updateField',
	});

	export default {
		name: 'GeneralForm',
		computed: {
			...mapState({
				isSaving: state => state.project.isSavingProject
			}),
			...mapFields([
				'projectDetail.name',
				'projectDetail.url',
			]),
		},
		methods: {
			save() {
				this.$emit('save');
			}
		}
	};
</script>

<style scoped>

</style>
